var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.8125H48V48.8125H0V0.8125Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6213 40.9249L16.2944 38.7019C17.0032 39.9583 17.6478 41.0214 19.1941 41.0214C20.6763 41.0214 21.611 40.4417 21.611 38.1864V22.8493H26.1217V38.2502C26.1217 42.9221 23.383 45.0487 19.3874 45.0487C15.779 45.0487 13.6844 43.1799 12.6211 40.9245M28.5717 40.4415L32.2445 38.3151C33.2114 39.894 34.468 41.0539 36.691 41.0539C38.5602 41.0539 39.752 40.1194 39.752 38.8305C39.752 37.284 38.5276 36.7361 36.4655 35.8342L35.338 35.3505C32.0836 33.9654 29.9249 32.2254 29.9249 28.5523C29.9249 25.1691 32.5025 22.5913 36.5302 22.5913C39.3978 22.5913 41.4599 23.5903 42.9419 26.2001L39.4297 28.4557C38.6562 27.0703 37.8188 26.5226 36.53 26.5226C35.2088 26.5226 34.3711 27.3604 34.3711 28.4557C34.3711 29.8089 35.2088 30.357 37.142 31.1947L38.2696 31.6779C42.104 33.3214 44.2627 34.9967 44.2627 38.7662C44.2627 42.8263 41.0729 45.0493 36.7876 45.0493C32.599 45.0493 29.8925 43.0517 28.5715 40.4417",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.8125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.e881deb01cff52e7c40cedbb15183db8.svg";
export { ForwardRef as ReactComponent };